import { ObjectSchema, object, string, number, mixed } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Eap, EapScreenDisplayType, eapScreenDisplay } from './../../models/eap';
yup.setLocale(locale);

export const eapLocationLenLimit = 16;

export function eapValidator(): ObjectSchema<Eap> {
    return object({
        id: string().uuid().strict(),

        vesselId: string().uuid().strict(),

        eapLedPatternId: string().uuid().nullable().strict(),

        index: number().required().nonNullable().strict(),

        screenDisplay: mixed<EapScreenDisplayType>()
            .oneOf(Object.values(eapScreenDisplay))
            .required()
            .nonNullable()
            .strict(),

        location: string().required().nonNullable().strict().max(eapLocationLenLimit),
    })
        .strict()
        .noUnknown();
}
